'use client';
import './CarModelStyles.scss';
import CarModelVariants from './Variants/CarModelVariants';
import { useState } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelStyles({ fields }) {
  const [activeStyle, setActiveStyle] = useState(fields?.styles?.[0]);

  const handleSetActiveStyle = (value) => {
    setActiveStyle(value);
  };

  return (
    <div className={'container car-model-styles'}>
      <div className={'wrapper'} id="Design">
        <div className={'imageContainer'} data-aos="fade-up">
          <div className={'image'}>
            <Image alt="car styles" field={activeStyle?.fields?.styleImage} fill />
          </div>
          <div className={'imageMobile'}>
            <Image alt="car styles" field={activeStyle?.fields?.styleImageMobile} fill />
          </div>
        </div>
        <div className={'content'} data-aos="fade-up">
          <div className={'content_text'}>
            <p className={'content_description'}>{fields?.title.value}</p>
            <span className={'content_headline'}>{activeStyle.fields.text.value}</span>
          </div>
          <div className={'variants'}>
            <CarModelVariants
              itemsJaecooJ7Phev={fields?.styles}
              activeStyle={activeStyle}
              onSetActiveStyle={handleSetActiveStyle}
            />
          </div>
        </div>
        <div className={'mobileVariants'} data-aos="fade-up">
          <CarModelVariants
            itemsJaecooJ7Phev={fields?.styles}
            activeStyle={activeStyle}
            onSetActiveStyle={handleSetActiveStyle}
          />
          <p className={'mobileVariants_text'}>{activeStyle.fields.text.value}</p>
        </div>
      </div>
    </div>
  );
}
